module.exports = __webpack_public_path__ + "img/Pic_ZS_ZXDZ.9fdc9abe.png";